module.exports = __webpack_public_path__ + "assets/arc-arrow.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arc-arrow.png
// module id = 1222
// module chunks = 7